<div *ngIf="visible" (click)="_select()" class="space-x-1" style="display: flex; align-items: center">
  <ng-container *ngIf="filter.v && filter.v.length">
    <div *ngFor="let c of filter.v" class="app-chip">
      {{ c.name }}
      <fa-icon [icon]="faTimes" (click)="remove(c, $event)"></fa-icon>
    </div>

    <div>
      <fa-icon [icon]="faTimes" (click)="clear($event)"></fa-icon>
    </div>
  </ng-container>
  <ng-container *ngIf="!filter.v || !filter.v.length">
    <ng-content></ng-content>
  </ng-container>
</div>